var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpeningKenhtv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 22,
    viewBox: "0 0 27 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1326 20.6817L16.3839 19.4262H9.64972L7.90108 20.6817C7.42108 21.1682 7.76328 22 8.44057 22H17.5931C18.2714 22 18.6116 21.1671 18.1326 20.6817Z",
    fill: "#406EE2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4584 0H2.57542C1.15322 0 0 1.16748 0 2.60727V15.9242C0 17.364 1.15322 18.5314 2.57542 18.5314H23.4584C24.8806 18.5314 26.0339 17.364 26.0339 15.9242V2.60727C26.0339 1.16748 24.8806 0 23.4584 0ZM11.8088 7.12842H10.3139V13.1197H8.36643V7.12842H6.86186V5.39625H11.8088V7.12842ZM16.6149 13.1197H14.6069L12.0605 5.39574H14.0583L15.5934 10.8115H15.6183L17.1635 5.39574H19.1715L16.6149 13.1197Z",
    fill: "#406EE2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpeningKenhtv);
export default __webpack_public_path__ + "static/media/opening-kenhtv.1ea9f4867ed720ecd74c9eb39831d804.svg";
export { ForwardRef as ReactComponent };